import gql from 'graphql-tag';

export const getCommercialJobRoles = gql`
  query getCommercialJobRoles {
    getCommercialJobRoles {
      id
      name
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
    }
  }
`;
